/* eslint-disable radix */
/* ============
 * Edit Page
 * ============
 *
 * This page edits campaign.
 */

import { mapGetters, mapMutations } from 'vuex';
import Forms from './../../../../utils/forms/forms';
import campaignService from './../../../../services/campaign';
import newsService from './../../../../services/news';
import clientCampaignService from './../../../../services/clientCampaign';
import clientService from './../../../../services/client';
import clientGroupService from './../../../../services/client-group';
import campaignTypeService from './../../../../services/campaignType';
import subscriberListService from './../../../../services/subscriberList';
import campaignTransformer from './../../../../transformers/campaign';
import AddEmail from './../../../../components/addEmail/addEmail.vue';
import emailSendTracking from './../../../../components/emailSendTracking/emailSendTracking.vue';
import LineChart from './../../../../components/widgetsChart/line/line.vue';
import moment from 'moment';

export default {
  data() {
    return {
      form: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        description: {
          value: '',
          type: 'textarea',
        },
        campaignTypeId: {
          value: '',
          type: 'select',
        },
        newsSubscriberListId: {
          value: '',
          type: 'select',
        },
      }),
      emails: {},
      clients: {},
      allClients: [],
      allClientGroups: [],
      selectedClients: [],
      selectedClientGroups: [],
      selectClientError: '',
      selectClientGroupError: '',
      addingClients: false,
      addingClientGroups: false,
      currentCampaign: {},
      loading: false,
      loadingEmails: true,
      loadingClients: true,
      activeName: 'overview',
      emailTracking: {
        defaultDate: new Date(),
        emailTrackingRecipients: [],
        emailSubject: [],
        selectNewsId: 0,
        selectEmailSubject: '',
        countType: 'opened',
        datesFromTwoDates: [],
        lineChartLabel: this.$t('static.campaigns.edit.emailTracking.countLabel.opened'),
        iconCountData: {
          opened: 0,
          delivered: 0,
          clicked: 0,
          dropped: 0,
          bounced: 0,
          complained: 0,
          failed: 0,
          unsubscribed: 0,
        },
        iconActive: {
          opened: '',
          delivered: '',
          clicked: '',
          dropped: '',
          bounced: '',
          complained: '',
          failed: '',
          unsubscribed: '',
        },
        dateRangDisplay: '',
        selectedDayOrRangeText: '',
        selectDayOrRange: {},
        selectDayOrRangeVisble: false,
        selectDayOrRangeOption: [{
          group: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.group1'),
          item: { today: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.today'), all: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.all') },
        },
        {
          group: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.group2'),
          item: { date_range: this.$t('static.campaigns.edit.emailTracking.dateRangDropDown.dateRange') },
        }],
        pickerOptions: {
          shortcuts: [{
            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.last3Days'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.lastWeek'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.lastMonth'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          }, {
            text: this.$t('static.campaigns.edit.emailTracking.datePicker.shortcut.last3Month'),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          }],
        },
        selectRange: '',
        countDataSet: {
          opened: [],
          delivered: [],
          clicked: [],
          dropped: [],
          bounced: [],
          complained: [],
          failed: [],
          unsubscribed: [],
        },
        lineChart: {
          options: {
            plugins: {
              datalabels: {
                display: true,
                align: 'center',
                anchor: 'center',
              },
            },
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                left: 0, right: 0, top: 0, bottom: 0,
              },
            },
            legend: {
              display: true,
              position: 'left',
              labels: {
                boxWidth: 4,
              },
            },
            tooltips: {
              enabled: true,
            },
          },
          chartData: {
            labels: [],
            datasets: [{
              label: '',
              data: [],
            }],
          },
        },
        loaded: false,
      },
      ifListNotSet: null,
    };
  },

  computed: {
    ...mapGetters({
      campaignTypes: 'campaignTypes',
      allSubscriberList: 'allSubscriberList',
    }),

    allClientsList() {
      return this.allClients.map(c => (
        { id: c.id, name: c.name || `${c.firstName} ${c.lastName}` }
      ));
    },
  },

  watch: {
    /**
     * Watches campaign types to inject on form.
     *
     * @param {Array} campaignTypes Types of campaign.
     */
    campaignTypes(campaignTypes) {
      this.form.setOptions('campaignTypeId', campaignTypes);
    },

    /**
     * Watches allSubscriberList to inject on form.
     *
     * @param {Array} allSubscriberList Types of campaign.
     */
    allSubscriberList(allSubscriberList) {
      this.form.setOptions('newsSubscriberListId', allSubscriberList.items);
    },

  },

  created() {
    this.form.setTooltip('campaignTypeId', this.$t('static.campaigns.create.campaignTypeTooltip'));
    this.show();
    this.showEmailTracking();
  },


  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    redirectEditCampaign() {
      this.activeName = 'editcampaign';
    },

    /**
     * Method to update the campaign.
     */
    update() {
      this.form.loading = true;
      const campaign = campaignTransformer.send(this.form.data());
      campaignService.update(this.$route.params.id, campaign)
      .then(() => {
        this.form.loading = false;
        this.form.successMessage = this.$t('static.campaigns.edit.updateSuccess');
        campaignService.show(this.$route.params.id).then((c) => {
          this.currentCampaign = c;
        });
      }).catch((errors) => {
        this.form.loading = false;
        this.form.recordErrors(errors);
      });
    },

    /**
     * Fetches the campaign object for editing.
     */
    show() {
      this.loading = true;
      Promise.all([
        campaignService.show(this.$route.params.id),
        campaignTypeService.all(),
        subscriberListService.all(),
      ]).then((data) => {
        this.fetchEmails();
        this.fetchClients();
        this.fetchAllClients();
        this.fetchAllClientGroups();
        this.currentCampaign = data[0];
        const campaign = data[0];
        this.loading = false;
        this.form.assignData(campaign);
        if (this.form.newsSubscriberListId === 0) {
          this.form.setFieldValue('newsSubscriberListId', '');
          this.ifListNotSet = this.$t('static.campaigns.listNotSetup');
          this.form.recordErrors({ newsSubscriberListId: [this.ifListNotSet] });
        }
      });
    },

    /**
     * Get paginated emails from campaign.
     *
     * @param {Number} page Page number.
     */
    fetchEmails(page) {
      this.loadingEmails = true;
      newsService.items(this.$route.params.id, page).then((emails) => {
        this.loadingEmails = false;
        this.emails = emails;
        const self = this;
        emails.items.forEach((item) => {
          self.emailTracking.emailSubject.push({ label: item.subject, value: item.id });
        });

        this.emailTracking.selectEmailSubject = emails.items[0].id;
        this.emailTracking.selectDayOrRange = { value: 'today', label: 'Today' };
        this.onSelectEmailSubject(this.emailTracking.selectEmailSubject);
      });
    },

    /**
     * Get paginated clients from campaign.
     *
     * @param {Number} page Page number.
     */
    fetchClients(page) {
      this.loadingClients = true;
      clientCampaignService.items(this.$route.params.id, page).then((clients) => {
        this.loadingClients = false;
        this.clients = clients;
      });
    },

    /**
     * Get all clients.
     */
    fetchAllClients() {
      clientService.all().then((clients) => {
        this.allClients = clients;
      });
    },

    /**
     * Get all client groups.
     */
    fetchAllClientGroups() {
      clientGroupService.all().then((groups) => {
        this.allClientGroups = groups;
      });
    },

    openAddEmail() {
      this.setModalContent(() => AddEmail);
      this.setModalProps({
        create: this.addEmail,
        test: this.testEmail,
        campaign: this.currentCampaign,
        listMessage: this.ifListNotSet,
      });
      this.toggleModal(true);
    },

    addEmail(data) {
      return newsService.store(data).then(() => {
        this.fetchEmails();
      });
    },

    openEditEmail(email) {
      this.setModalContent(() => AddEmail);
      this.setModalProps({
        create: this.editEmail,
        test: this.testEmail,
        campaign: this.currentCampaign,
        email,
        listMessage: this.ifListNotSet,
      });
      this.toggleModal(true);
    },

    editEmail(data, id) {
      return newsService.update(id, data).then(() => {
        this.fetchEmails();
      });
    },

    /**
     * Send test email.
     */
    testEmail(data) {
      return newsService.test(data);
    },

    /**
     * Add clients to campaign..
     */
    addClients(groups = false) {
      const data = !groups ?
      { clients: this.selectedClients } :
      { groups: this.selectedClientGroups };
      if (!groups) {
        this.addingClients = true;
      } else {
        this.addingClientGroups = true;
      }
      clientCampaignService.store(this.$route.params.id, data)
      .then(() => {
        this.fetchClients(this.clients.pagination.currentPage);
        this.addingClients = false;
        this.addingClientGroups = false;
        this.selectedClients = [];
        this.selectedClientGroups = [];
      }).catch((errors) => {
        this.addingClients = false;
        this.addingClientGroups = false;
        if (errors.clients) {
          this.$message({
            showClose: true,
            message: errors.clients[0],
            type: 'error',
          });
        } else if (errors.groups) {
          this.$message({
            showClose: true,
            message: errors.groups[0],
            type: 'error',
          });
        }
      });
    },

    /**
     * Delete the given email.
     *
     * @param {Object} email The email object.
     */
    deleteEmail(email) {
      this.$confirm(this.$t('static.news.index.confirmDelete'), this.$t('static.news.index.confirmDeleteTitle'), {
        confirmButtonText: this.$t('button.delete'),
        cancelButtonText: this.$t('button.cancel'),
        type: 'warning',
      }).then(() => {
        newsService.destroy(email.id)
        .then(() => this.fetchEmails())
        .catch(() => {
          const message = this.$t('static.news.index.deleteError');
          this.$message({
            showClose: true,
            message,
            type: 'error',
          });
        });
      }).catch(() => {

      });
    },

    /**
     * Removes client from campaign.
     *
     * @param {Object} client The client object.
     */
    deleteClient(client) {
      clientCampaignService.destroy(this.$route.params.id, client.id)
      .then(() => this.fetchClients(this.clients.pagination.currentPage))
      .catch(() => {
        const message = this.$t('static.campaigns.edit.removeClientError');
        this.$message({
          showClose: true,
          message,
          type: 'error',
        });
      });
    },

    /**
     * Activate tab.
     *
     * @param {String} name Tab name.
     */
    activate(name) {
      this.activeName = name;
    },

    onChange(name, value) {
      this[name] = value;
    },


    /**
     * Show success email with each date
     */
    sentStatusTracking(e) {
      this.setModalContent(() => emailSendTracking);
      this.setModalProps({
        emailId: parseInt(e.id),
        emailSendTracking: e.emailSendTracking,
        emailSubject: e.subject,
        emailSuccesCount: e.sentSuccess,
        emailFailedCount: e.sentFailed,
        emailSendReport: this.sendReport,
      });
      this.toggleModal(true);
      // console.log(status);
    },

    sendReport(data) {
      return newsService.sendReport(data).then(() => {});
    },

    /**
     * Initialize email tracking
     */
    showEmailTracking() {
      const start = new Date();
      const end = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.emailTracking.selectRange = [
        `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`,
        `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`,
      ];
    },

    /**
     * Day or date range on change
     */
    onSelectDayOrRange(value) {
      this.emailTracking.selectedDayOrRangeText = value.label;
      if (value.value === 'date_range') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.opened');
        this.emailTracking.selectDayOrRangeVisble = true;
      } else {
        this.emailTracking.selectDayOrRangeVisble = false;
      }
      this.reQueryEmailTracking();
    },

    /**
     * Get dates between two dates
     */
    getDatesFromTwoDates(startDateVal, stopDateVal) {
      const dateArray = [];
      let currentDate = moment(startDateVal);
      const stopDate = moment(stopDateVal);
      while (currentDate <= stopDate) {
        dateArray.push(moment(currentDate.toString()).format('MMM Do YYYY'));
        currentDate = moment(currentDate).add(1, 'days');
      }
      this.emailTracking.datesFromTwoDates = dateArray; // [...new Set(dateArray)];
    },

    /**
     * On date picker change
     */
    onChangeDate(value) {
      this.getDatesFromTwoDates(new Date(value[0]), new Date(value[1]));
      this.reQueryEmailTracking();
    },

    /**
     * Re-initialize line chart
     */
    showChartOf(type) {
      this.emailTracking.countType = type;
      this.clearActiveIcon();
      this.updateLineChart();
      // console.log(type);
    },

    /**
     *
     * When new range select
     */
    updateLineChart() {
      if (this.emailTracking.countType === 'opened') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.opened');
        this.emailTracking.iconActive.opened = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.opened);
      } else if (this.emailTracking.countType === 'delivered') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.delivered');
        this.emailTracking.iconActive.delivered = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.delivered);
      } else if (this.emailTracking.countType === 'clicked') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.clicked');
        this.emailTracking.iconActive.clicked = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.clicked);
      } else if (this.emailTracking.countType === 'dropped') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.dropped');
        this.emailTracking.iconActive.dropped = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.dropped);
      } else if (this.emailTracking.countType === 'bounced') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.bounced');
        this.emailTracking.iconActive.bounced = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.bounced);
      } else if (this.emailTracking.countType === 'complained') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.complained');
        this.emailTracking.iconActive.complained = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.complained);
      } else if (this.emailTracking.countType === 'failed') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.failed');
        this.emailTracking.iconActive.failed = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.failed);
      } else if (this.emailTracking.countType === 'unsubscribed') {
        this.emailTracking.lineChartLabel = this.$t('static.campaigns.edit.emailTracking.countLabel.unsubscribed');
        this.emailTracking.iconActive.unsubscribed = 'active-icon';
        this.lineChartReInitialize(this.emailTracking.countDataSet.unsubscribed);
      }
    },

    /**
     * Re-initialize dataset
     */
    lineChartReInitialize(dataSet) {
      this.emailTracking.lineChart.chartData = {
        labels: this.emailTracking.datesFromTwoDates,
        datasets: [
          {
            label: this.emailTracking.lineChartLabel,
            backgroundColor: '#1bbc9b',
            data: dataSet,
          },
        ],
      };
    },

    /**
     * Clear all active icon
     */
    clearActiveIcon() {
      this.emailTracking.iconActive = {
        opened: '',
        delivered: '',
        clicked: '',
        dropped: '',
        bounced: '',
        complained: '',
        failed: '',
        unsubscribed: '',
      };
    },

    /**
     * Clear all count icon
     */
    clearCountIcon() {
      this.emailTracking.iconCountData = {
        opened: 0,
        delivered: 0,
        clicked: 0,
        dropped: 0,
        bounced: 0,
        complained: 0,
        failed: 0,
        unsubscribed: 0,
      };
    },

    /**
     * Clear all count icon
     */
    clearCountDataSet() {
      this.emailTracking.countDataSet = {
        opened: [],
        delivered: [],
        clicked: [],
        dropped: [],
        bounced: [],
        complained: [],
        failed: [],
        unsubscribed: [],
      };
    },

    /**
     * On select email subject and get related email trackings
     */
    onSelectEmailSubject(newsId) {
      this.emailTracking.selectNewsId = newsId;
      this.reQueryEmailTracking();
    },

    /**
     * Re query email tracking when event trigger
     */
    reQueryEmailTracking() {
      this.clearCountIcon();
      this.clearCountDataSet();
      this.emailTracking.datesFromTwoDates = [];
      this.emailTracking.emailTrackingRecipients = [];
      newsService.newsEmailTrackings(
        this.emailTracking.selectNewsId,
        this.emailTracking.selectDayOrRange.value,
        this.emailTracking.selectRange,
      ).then((data) => {
        this.emailTracking.loaded = true;
        this.emailTracking.emailTrackingRecipients = data.email_tracking_recipients;

        /**
         * Get by today
         */
        if (this.emailTracking.selectDayOrRange.value === 'today') {
          this.loopingIconCount(data);
        }

        /**
         * Get by all
         */
        else if (this.emailTracking.selectDayOrRange.value === 'all') {
          this.emailTracking.dateRangDisplay = `${moment(data[data.length - 2]).format('MMM Do YYYY')} - ${moment(data[data.length - 1]).format('MMM Do YYYY')}`;
          this.loopingIconCount(data);
        }

        /**
         * Get by date range
         */
        else if (this.emailTracking.selectDayOrRange.value === 'date_range') {
          this.emailTracking.dateRangDisplay = `${moment(this.emailTracking.selectRange[0]).format('MMM Do YYYY')} - ${moment(this.emailTracking.selectRange[1]).format('MMM Do YYYY')}`;
          this.updateLineChart();
          this.loopingIconCount(data);
        }
        this.updateLineChart();
        this.emailTracking.loaded = false;
      });
    },

    loopingIconCount(dataFrom) {
      const data = dataFrom.email_tracking_recipients; // .reverse();
      const self = this;

      data.forEach((item2) => {
        const eventTimestamp = moment(item2.event_timestamp).format('MMM Do YYYY');
        self.emailTracking.datesFromTwoDates.push(eventTimestamp);

        if (item2.email_event_type.name === 'Opened') { self.isExistAdd(self.emailTracking.countDataSet.opened, eventTimestamp, item2.count); }

        if (item2.email_event_type.name === 'Delivered') { self.isExistAdd(self.emailTracking.countDataSet.delivered, eventTimestamp, item2.count); }

        if (item2.email_event_type.name === 'Clicked') { self.isExistAdd(self.emailTracking.countDataSet.clicked, eventTimestamp, item2.count); }

        if (item2.email_event_type.name === 'Dropped') { self.isExistAdd(self.emailTracking.countDataSet.dropped, eventTimestamp, item2.count); }

        if (item2.email_event_type.name === 'Bounced') { self.isExistAdd(self.emailTracking.countDataSet.bounced, eventTimestamp, item2.count); }

        if (item2.email_event_type.name === 'Complained') { self.isExistAdd(self.emailTracking.countDataSet.complained, eventTimestamp, item2.count); }

        if (item2.email_event_type.name === 'Failed') { self.isExistAdd(self.emailTracking.countDataSet.failed, eventTimestamp, item2.count); }

        if (item2.email_event_type.name === 'Unsubscribed') { self.isExistAdd(self.emailTracking.countDataSet.unsubscribed, eventTimestamp, item2.count); }

        self.emailTracking.iconCountData.opened += (item2.email_event_type.name === 'Opened') ? parseInt(item2.count) : 0;
        self.emailTracking.iconCountData.delivered += (item2.email_event_type.name === 'Delivered') ? parseInt(item2.count) : 0;
        self.emailTracking.iconCountData.clicked += (item2.email_event_type.name === 'Clicked') ? parseInt(item2.count) : 0;
        self.emailTracking.iconCountData.dropped += (item2.email_event_type.name === 'Dropped') ? parseInt(item2.count) : 0;
        self.emailTracking.iconCountData.bounced += (item2.email_event_type.name === 'Bounced') ? parseInt(item2.count) : 0;
        self.emailTracking.iconCountData.complained += (item2.email_event_type.name === 'Complained') ? parseInt(item2.count) : 0;
        self.emailTracking.iconCountData.failed += (item2.email_event_type.name === 'Failed') ? parseInt(item2.count) : 0;
        self.emailTracking.iconCountData.unsubscribed += (item2.email_event_type.name === 'Unsubscribed') ? parseInt(item2.count) : 0;
      });

      this.emailTracking.datesFromTwoDates = [...new Set(this.emailTracking.datesFromTwoDates)];
      this.emailTracking.countDataSet.opened = this.emailTracking.countDataSet.opened.reverse();
      this.emailTracking.countDataSet.clicked = this.emailTracking.countDataSet.clicked.reverse();
      this.emailTracking.countDataSet.dropped = this.emailTracking.countDataSet.dropped.reverse();
      this.emailTracking.countDataSet.bounced = this.emailTracking.countDataSet.bounced.reverse();
      this.emailTracking.countDataSet.complained = this.emailTracking.countDataSet.complained.reverse();
      this.emailTracking.countDataSet.failed = this.emailTracking.countDataSet.failed.reverse();
      this.emailTracking.countDataSet.unsubscribed = this.emailTracking.countDataSet.unsubscribed.reverse();

    },

    isExistAdd(data, timestamp, count) {
      const isExist = data.filter(element => (element.t === timestamp));

      if (isExist.length < 1) data.push({ t: timestamp, y: count });
      else data[0].y = parseInt(data[0].y) + parseInt(count);
    },

  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
    VSelect: require('./../../../../components/form/select/select.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
    LineChart,
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/campaigns/edit/edit.js